/* eslint-disable no-case-declarations */
/* eslint-disable array-callback-return */
import {
  TimeStampIntoHours,
  createdAsFunction
} from "../../constant/helper/helper";
import isEmpty from "../../validation/isEmpty";
import { types } from "../type";

const initialState = {
  date: "",
  dataRange: 1,
  toDate: "",
  fromDate: "",
  locationId: "1",
  dataFormat: "ABP",
  attendanceError: "",
  attendanceStatus: 0,
  selectedInputs: [],
  attendanceResponse: "",
  dailyAttendances: null,
  attendanceLoading: false,
  attendanceSheetData: null,
  attendanceDynamicSheetData: null,
  missingAttendanceUserError: null,
  shiftSheetData: null,
  dailyDepartmentAttendance: []
};

const attendanceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.AttendanceTypes.ATTENDANCE_SET_LOADING:
      return {
        ...state,
        attendanceLoading: payload
      };

    case types.AttendanceTypes.ATTENDANCE_CLEAR_ERRORS:
      return {
        ...state,
        attendanceError: ""
      };
    case types.AttendanceTypes.ATTENDANCE_GET_ERRORS:
      return {
        ...state,
        attendanceLoading: false,
        attendanceError: payload.data.message,
        attendanceStatus: payload.status
      };
    case types.AttendanceTypes.ATTENDANCE_CLEAR_RESULT:
      return {
        ...state,
        attendanceResponse: ""
      };
    case types.AttendanceTypes.GET_DAILY_ATTENDANCE:
      const dailyAttendanceArray = payload.data.dailyAttendance.map(
        (attendanceData) => {
          const newArrayDynamic = [];
          payload.payloadData.map((selectValue) => {
            newArrayDynamic.push({
              label: selectValue.label,
              value: !isEmpty(attendanceData.attendances)
                ? attendanceData.attendances[selectValue.value]
                : ""
            });
          });
          const newArray = Object.assign({}, attendanceData);
          if (!isEmpty(newArray.attendances)) {
            Object.entries(attendanceData.attendances).forEach(
              ([key, value]) => {
                newArray[key] = value;
              }
            );
          }

          newArray.createdAs = createdAsFunction(
            attendanceData.attendances
          );
          newArray.workerFullName =
            attendanceData.workerFirstName +
            " " +
            attendanceData.workerSurname;
          newArray.inTime = TimeStampIntoHours(
            attendanceData?.attendances?.inTime
          );
          newArray.outTime = TimeStampIntoHours(
            attendanceData?.attendances?.outTime
          );
          newArray.detections = attendanceData.detections;

          newArray.employeeId = attendanceData._id;

          newArray.dataArray = newArrayDynamic;
          newArray.zoneId = attendanceData?.zoneId;

          !isEmpty(newArray.attendances) &&
            delete newArray.attendances;
          delete newArray.workerFirstName;
          delete newArray.workerSurname;

          return newArray;
        }
      );

      return {
        ...state,
        attendanceLoading: false,
        dailyAttendances: dailyAttendanceArray
      };
    case types.AttendanceTypes.GET_ATTENDANCE_SHEET:
      return {
        ...state,
        attendanceLoading: false,
        attendanceSheetData: payload.data.attendanceSheet
      };
    case types.AttendanceTypes.GET_ATTENDANCE_DYNAMIC_SHEET:
      return {
        ...state,
        attendanceLoading: false,
        attendanceDynamicSheetData: payload.data.attendanceSheet
      };
    case types.AttendanceTypes.GET_SHIFT_SHEET:
      return {
        ...state,
        attendanceLoading: false,
        shiftSheetData: payload.data.allShifts
      };
    case types.AttendanceTypes.UPDATE_SHIFT_SHEET:
      return {
        ...state,
        attendanceLoading: false,
        attendanceResponse: payload.message
      };
    case types.AttendanceTypes.ADD_DAILY_MISSING_ATTENDANCE:
      return {
        ...state,
        attendanceLoading: false,
        missingAttendanceUserError: payload.errors,
        attendanceResponse: payload.message
      };
    case types.AttendanceTypes.ADD_DAILY_SINGLE_MISSING_ATTENDANCE:
      return {
        ...state,
        attendanceLoading: false,
        attendanceResponse: payload.message
      };
    case types.AttendanceTypes.GET_DAILY_DEPARTMENT_ATTENDANCE:
      return {
        ...state,
        attendanceLoading: false,
        dailyDepartmentAttendance:
          payload.data.dailyDepartmentAttendance
      };
    case types.AttendanceTypes.ATTENDANCE_UNMOUNT:
      return {
        ...state,
        date: "",
        toDate: "",
        fromDate: "",
        locationId: "",
        attendanceError: "",
        attendanceStatus: "",
        dailyAttendances: null,
        attendanceSheetData: null
      };
    case types.AttendanceTypes.SHEET_INPUTS:
      return {
        ...state,
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        locationId: payload.locationId,
        dataFormat: payload.dataFormat,
        dataRange: !isEmpty(payload.dataRange)
          ? payload.dataRange
          : state.dataRange
      };
    case types.AttendanceTypes.DAILY_ATT_INPUTS:
      return {
        ...state,
        date: payload.date,
        locationId: payload.locationId,
        selectedInputs: payload.selectedCategory
      };
    default:
      return state;
  }
};

export default attendanceReducer;
